// سقف الكمية الافتراضي لأي مادة (رسام أو ورشة)
export const DEFAULT_MAX_QTY = 10;

// استثناءات على السقف الافتراضي حسب اسم المادة نفسه (مثلاً الخشب بالورشة)
export const ITEM_MAX_QTY_OVERRIDES = {
  "خشب": 200,
  "علبة كلبس دوشمه": 10,
  "علبة بسامير كبس": 10,
  "علبة جويات + براغي 6 ملم": 10,
  "علبة جويات + براغي 8 ملم": 10,
  "برينة دريل همر 5 ملم": 2,
  "برينة دريل همر 6 ملم": 2,
  "برينة دريل همر 8 ملم": 2,
  "برينة دريل شحن كونكريت 5 ملم": 2,
  "برينة دريل شحن كونكريت 6 ملم": 2,
  "برينة دريل شحن كونكريت 8 ملم": 2,
};

export function getMaxQtyForItem(label) {
  return ITEM_MAX_QTY_OVERRIDES[label] ?? DEFAULT_MAX_QTY;
}
